import { type InputHTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Input variant definitions built with `class-variance-authority`.
 *
 * ### Sizes
 * | inputSize | height | usage                    |
 * |-----------|--------|--------------------------|
 * | `sm`      | 40px   | Compact forms            |
 * | `md`      | 48px   | Default — auth forms     |
 * | `lg`      | 56px   | Large / hero inputs      |
 */
const inputVariants = cva(
  [
    'w-full font-sans text-primary bg-surface',
    'border border-border rounded-card px-4',
    'placeholder:text-muted',
    'focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent',
    'disabled:opacity-50 disabled:pointer-events-none',
    'transition-colors',
  ].join(' '),
  {
    variants: {
      inputSize: {
        sm: 'h-10 text-sm',
        md: 'h-12 text-base',
        lg: 'h-14 text-lg',
      },
    },
    defaultVariants: {
      inputSize: 'md',
    },
  },
);

export type InputProps = InputHTMLAttributes<HTMLInputElement> & VariantProps<typeof inputVariants>;

export { inputVariants };
